import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class PlClientEntitiesDataService<T extends { uuid?: string }> {
  constructor(private http: HttpClient, private url: string) {}

  get(options?: Parameters<typeof this.http.get>[1]): Observable<T[]> {
    return this.http.get<T[]>(this.url, options);
  }

  add(data: T): Observable<T> {
    return this.http.post<T>(this.url, data);
  }

  edit(data: T): Observable<T> {
    const url = `${this.url}${data.uuid}/`;
    return this.http.put<T>(url, data);
  }

  delete(uuid: string): Observable<any> {
    const url = `${this.url}${uuid}/`;
    return this.http.delete(url);
  }
}
